import { useDataModel } from '@thd-nucleus/data-sources';

export const useSubmitReport = (formData) => {
  const [submitReport, response] = useDataModel('submitReviewFeedback', {
    variables: formData,
    lazy: true,
  });
  return [submitReport, response];
};
